// extracted by mini-css-extract-plugin
module.exports = {"content":"Y7skI","logo":"aKGDy"};